import { render, staticRenderFns } from "./ImportConceptFromModel.vue?vue&type=template&id=780d58ea&"
import script from "./ImportConceptFromModel.vue?vue&type=script&lang=ts&"
export * from "./ImportConceptFromModel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports